// Mirrors Stripe.Invoice.BillingReason
export enum StripeInvoiceBillingReason {
	AUTOMATIC_PENDING_INVOICE_ITEM_INVOICE = "automatic_pending_invoice_item_invoice",
	MANUAL = "manual",
	QUOTE_ACCEPT = "quote_accept",
	SUBSCRIPTION = "subscription",
	SUBSCRIPTION_CREATE = "subscription_create",
	SUBSCRIPTION_CYCLE = "subscription_cycle",
	SUBSCRIPTION_THRESHOLD = "subscription_threshold",
	SUBSCRIPTION_UPDATE = "subscription_update",
	UPCOMING = "upcoming",
}

// Mirrors Stripe.Invoice.Status
export enum StripeInvoiceStatus {
	DRAFT = "draft",
	OPEN = "open",
	PAID = "paid",
	UNCOLLECTIBLE = "uncollectible",
	VOID = "void",
}

// Mirrors Stripe.Plan.Interval
export enum StripePlanInterval {
	DAY = "day",
	WEEK = "week",
	MONTH = "month",
	YEAR = "year",
}

// Mirrors Stripe.Price.BillingScheme
export enum StripePriceBillingScheme {
	PER_UNIT = "per_unit",
	TIERED = "tiered",
}

// Mirrors Stripe.Subscriptions.Status
export enum StripeSubscriptionStatus {
	ACTIVE = "active",
	CANCELED = "canceled",
	INCOMPLETE = "incomplete",
	INCOMPLETE_EXPIRED = "incomplete_expired",
	PAST_DUE = "past_due",
	PAUSED = "paused",
	TRIALING = "trialing",
	UNPAID = "unpaid",
}

// https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#example
export class StripeError extends Error {
	name: string;
	cause: any;

	constructor(...args: any[]) {
		// 'Error' breaks prototype chain here
		super(...args);

		// set name
		this.name = new.target.name;
		Object.setPrototypeOf(this, new.target.prototype);
	}
}

export class StripeCustomerDeletedError extends StripeError {}
export class StripeCustomerNotFoundError extends StripeError {}
export class StripeFailedToVoidInvoiceError extends StripeError {}
export class StripeNoConnectIdError extends StripeError {}
export class StripePaymentMethodIdMismatchError extends StripeError {}
